import { render } from "./AcceptedArtView.vue?vue&type=template&id=0269ca14&scoped=true"
const script = {}

import "./AcceptedArtView.vue?vue&type=style&index=0&id=0269ca14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0269ca14"]])

export default __exports__